import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { useAllNetworksQuery } from '@/modules/__generated__/graphql/switchboard-generated';
import type { Option } from '@/modules/shared/components/form/multiselect';
function useNetworkOptions() {
  const $ = _c(5);
  const {
    data: allNetworks,
    isLoading: isLoadingAllNetworks
  } = useAllNetworksQuery();
  let t0;
  if ($[0] !== allNetworks?.allNetworks) {
    t0 = allNetworks?.allNetworks.map(_temp) ?? [];
    $[0] = allNetworks?.allNetworks;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const options = t0 as Option[];
  let t1;
  if ($[2] !== isLoadingAllNetworks || $[3] !== options) {
    t1 = {
      options,
      isLoadingAllNetworks
    };
    $[2] = isLoadingAllNetworks;
    $[3] = options;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}
function _temp(network) {
  return {
    value: network.network?.slug ?? "",
    label: network.network?.name ?? network.network?.slug ?? "Unknown",
    group: "Networks"
  } satisfies Option;
}
export { useNetworkOptions };